import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useUserStore = defineStore('user', () => {
    const user = ref(null);

    const isLoggedIn = computed(() => {
        return user.value !== null;
    });

    const fetchMe = async () => {
        user.value = null;

        try {
            const response = await axios.get(`/api/me`);
            user.value = response.data.data;
        } catch(error) {}
    };

    const login = async (email, password) => {
        const params = {
            email: email,
            password: password,
        };

        const response = await axios.post(`/api/login`, params);

        if (response.data?.token) {
            axios.defaults.headers = { Authorization: `Bearer ${response.data.token}` };
            localStorage.setItem('bearerToken', response.data.token);
        }

        await fetchMe();
    };

    const logout = async () => {
        user.value = null;

        await axios.post(`/api/logout`);
    };

    return {
        user,
        isLoggedIn,
        fetchMe,
        login,
        logout,
    };
});
